import PropTypes from 'prop-types';
import localData from 'utils/localData';
import intl from 'react-intl-universal';

import { readableDateTimeFormat } from 'utils/dateTime';
import { Dates } from './Styles';
import { IssuePropTypes } from 'shared/propTypes/issueType';
import { getUserPreferredTimezone } from 'utils/formatTime';
import { USER_DATA } from 'shared/constants/users';
import logger from 'utils/logger';

const propTypes = {
  issue: PropTypes.shape(IssuePropTypes).isRequired,
};

const log = logger.createLogger('ProjectBoardIssueDetailsDates');

// Temporary
const TIMEZONE = {
  JST: 'Asia/Tokyo',
  CST: 'Asia/Shanghai',
};

const formDisplayString = (lang, datetimeString, timeZone) => {
  return intl.get('shared_date_format_created_at', {
    date: readableDateTimeFormat(datetimeString, lang, timeZone),
  });
};

const ProjectBoardIssueDetailsDates = ({ issue }) => {
  const lang = localData.get(USER_DATA.PREFFERED_LANGUAGE);
  const timeZone = getUserPreferredTimezone();
  const displayString = formDisplayString(
    lang,
    issue.createdAt,
    TIMEZONE[timeZone]
  );
  return (
    <Dates>
      <div>{displayString}</div>
    </Dates>
  );
};

ProjectBoardIssueDetailsDates.propTypes = propTypes;

export default ProjectBoardIssueDetailsDates;
